import { InputController } from "./InputController";
import { AccountingTargetListItem, ODataQueryOptions, AccountingTargets } from "@salaxy/core";
/**
 * Controller behind form controls that select an accounting target.
 */

export class InputAccountingTargetController extends InputController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["AccountingTargets"];
  public _accountingTargetDisplayItem: AccountingTargetListItem;
  /**
   * Creates a new InputAccountingTargetController
   * @ignore
   */
  constructor(private accountingTargets: AccountingTargets) {
    super();
  }

  /**
   * Query all available accountingTargets from index
   */
  public queryAccountingTargets(search: string): Promise<AccountingTargetListItem[]> {
    search = search ?? "";
    const queryOptions: ODataQueryOptions = {
      $search: search,
      $top: 50
    };
    return this.accountingTargets.getOData(queryOptions).then((result) => {
      return result.items;
    });
  }



  /**
   * Get selected accounting target displayName
   * @param accountingTargetId selected accounting target id
   * @param refresher helper for refreshing view after
   * @returns accountingTargetDisplayName from otherPartyInfo.avatar.displayName
   */
  public queryAccountingTargetDisplayName(accountingTargetId: string, refresher: any[]): string {
    if (!accountingTargetId) {
      return "";
    }
    if (this._accountingTargetDisplayItem && this._accountingTargetDisplayItem.id === accountingTargetId) {
      return this._accountingTargetDisplayItem.otherPartyInfo.avatar.displayName;
    }

    this._accountingTargetDisplayItem = {
      id: accountingTargetId,
      otherPartyInfo: {
        avatar: {
          displayName: accountingTargetId
        }
      }
    };

    const queryOptions: ODataQueryOptions = {
      $filter: `id eq '${accountingTargetId}_AccountingTargetDto'`,
      $top: 50
    };
    this.accountingTargets.getOData(queryOptions).then((result) => {
      this._accountingTargetDisplayItem = (result.items.find((item) => item.id === accountingTargetId)) ?? this._accountingTargetDisplayItem;
      refresher[0] = new Date().getTime();
    });
    return this._accountingTargetDisplayItem.otherPartyInfo.avatar.displayName;
  }

}
